import { memo, ReactNode } from 'react'
import cn from 'classnames'

import s from './ListCardTable.module.less'

interface IProps {
  children?: ReactNode
  className?: string
}

export const ListCardTable = memo<IProps>(function ListCardTable({ className, children }) {
  return <div className={cn(s.table, className)}>{children}</div>
})
